export const menuLabels = [
  // {id:2, label: "Payment", link:"/payment"},
  { id: 1, label: "Customers", link: "/admin/customers" },
  { id: 2, label: "Retailers", link: "/admin/retailers" },
  { id: 3, label: "Products", link: "/admin/products" },
  { id: 4, label: "Category", link: "/admin/category" },
  { id: 5, label: "Orders", link: "/admin/orders" },
  { id: 6, label: "Analytics", link: "/admin/analytics" },
  // { id: 5, label: "Referral", link: "/admin/referral" },
];
